module.exports = __webpack_public_path__ + "img/5b.29030b3b.svg";